import {
  NotificationTypeEnum,
  NotificationTypeEnumList,
} from "@core/modeles/Notifimodels.ts";

export function capitalizeFirstLetter(str: string): string {
  if (!str) return str;

  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalise chaque mot
    .join(" ");
}

export const formatPhoneNumber = (value: string) => {
  const cleaned = value.replace(/\s+/g, "").replace(/[^0-9]/g, "");
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 5) return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  if (cleaned.length <= 8)
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5)}`;
  return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(
    5,
    8
  )} ${cleaned.slice(8)}`;
};

export function applyFilter(
  event: React.ChangeEvent<HTMLInputElement>,
  dataSource: any
) {
  const filterValue = (event.target as HTMLInputElement).value
    .trim()
    .toLowerCase();
  return (dataSource.filter = filterValue.trim().toLowerCase());
}

//creation ovale pour le pointStyle chart line
export function createOval(color: string) {
  const canvas = document.createElement("canvas");
  canvas.width = 5; // Largeur plus petite (réduite à 1/2)
  canvas.height = 10; // Hauteur réduite également à 1/2
  const ctx = canvas.getContext("2d");

  if (ctx) {
    ctx.fillStyle = color; // Couleur noire par défaut
    ctx.beginPath();
    ctx.ellipse(
      canvas.width / 2, // Centre en X
      canvas.height / 2, // Centre en Y
      2.5, // Rayon horizontal (demi-largeur, réduit à 1/2)
      5, // Rayon vertical (demi-hauteur, réduit à 1/2)
      0, // Pas de rotation
      0,
      2 * Math.PI // Dessine un ovale complet
    );
    ctx.fill();
  }

  return canvas;
}

export function getHierarchy(
  data: any,
  codeSup: any,
  codeSub: any,
  selectedCode: any
) {
  const filteredArray = data
    .filter((item: any) => item[codeSup] === selectedCode)
    .map((item: any) => ({
      code: item[codeSub],
      name: item.nom_fokontany,
    }));

  const uniqueList = Array.from(
    new Map(filteredArray.map((item: any) => [item.code, item])).values()
  );
  return uniqueList;
}

export const formatFullName = (value: string) => {
  return value
    .toLowerCase()
    .split(" ")
    .map((word, index) =>
      index === 0
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
};

export function objectToArray(obj: any) {
  return Object.entries(obj).map(([key, value]) => ({ key, value }));
}

export const searchAutoComplete = (
  event: { query: string },
  data: any[],
  setState: React.Dispatch<React.SetStateAction<any[]>>
) => {
  const query = event.query.toLowerCase();
  const filtered = data.filter((d: any) =>
    d.name.toLowerCase().includes(query)
  );
  setState(filtered);
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR");
};

export const formatLongDate = (insertDate: any) =>{
  const date = new Date(insertDate);
const options: Intl.DateTimeFormatOptions = {
  day: '2-digit',        
  month: 'long',         
  year: 'numeric'        
};

const formattedDate = new Intl.DateTimeFormat('fr-FR', options).format(date);
return formattedDate;
}
export const getHour = (insertDate: any) =>{
  const options: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
};

const formattedTime = new Intl.DateTimeFormat('fr-FR', options).format(insertDate)
return formattedTime
}

export const dateTime = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInHours = Math.floor(
    (now.getTime() - date.getTime()) / (1000 * 60 * 60)
  );

  if (diffInHours < 1) return "À l'instant";
  if (diffInHours < 24) return `Il y a ${diffInHours}h`;
  if (diffInHours < 48) return "Hier";
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
  });
};

export interface PaginateResponse<T> {
  page: number;
  total: number;
  lastPage: number;
  data: T[];
}

export interface FokontanyDTO {
  id: number;
  name: string;
  code: string;
  municipality?: {
    id: number;
    name: string;
    code: string;
    district: {
      id: number;
      name: string;
      code: string;
      region: {
        id: number;
        name: string;
        code: string;
        districts: any[];
      };
      municipalities: any[];
    };
    fokontanies: any;
  };
}

export interface RegionDTO {
  id: number;
  name: string;
  code: string;
}

export interface DistrictDTO {
  id: number;
  name: string;
  code: string;
}

export interface CommuneDTO {
  id: number;
  name: string;
  code: string;
}

export const formatDateFr = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0"); // Ajoute un zéro devant si nécessaire
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Mois commence à 0
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getNotificationNameFromCode = (code: NotificationTypeEnum) => {
  const found = NotificationTypeEnumList.find((item) => item.code === code);
  return found ? found.name : null;
};
